import { useEffect } from 'react';

let lockCount = 0;
let savedOverflow = null;

function acquireLock() {
  if (typeof document === 'undefined') return;
  if (lockCount === 0) {
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  lockCount += 1;
}

function releaseLock() {
  if (typeof document === 'undefined') return;
  if (lockCount === 0) return;
  lockCount -= 1;
  if (lockCount === 0) {
    document.body.style.overflow = savedOverflow ?? '';
    savedOverflow = null;
  }
}

/**
 * Lock body scroll while `isLocked` is true. Multiple callers stack safely:
 * the lock is only released when every caller has released. The original
 * inline overflow value is restored, never hard-coded to '' or 'unset'.
 */
export default function useBodyScrollLock(isLocked) {
  useEffect(() => {
    if (!isLocked) return undefined;
    acquireLock();
    return () => releaseLock();
  }, [isLocked]);
}
